// Hash url for the homes result pages
const HomeListings = '#home-listings';

export default HomeListings;